/**
 * @todo Удалить файл с экспериментом
 * @description Данный функционал появился в задаче CD-158957, будет удалён в задаче CD-159236
 */

import { createSelector } from 'reselect';

import { abUseExperimentsSelector, getAbUseExperiment } from '../abUseExperiments';

export type TCommercialBestPlaceAnalyticsGroups = 'A' | 'B' | 'C';

export const COMMERCIAL_BEST_PLACE_ANALYTICS_EXPERIMENT = 'commercial_best_place_analytics';

export const selectCommercialBestPlaceAnalyticsExperimentGroup = createSelector(abUseExperimentsSelector, experiments =>
  getAbUseExperiment(experiments, COMMERCIAL_BEST_PLACE_ANALYTICS_EXPERIMENT),
);

export const selectCommercialBestPlaceAnalyticsExperimentGroupName = createSelector(
  selectCommercialBestPlaceAnalyticsExperimentGroup,
  group => (group ? (group.groupName as TCommercialBestPlaceAnalyticsGroups) : undefined),
);
